import { Component, OnInit } from '@angular/core';
import { ValidateService } from '../services/validate.service';
import { AuthService } from '../services/auth.service'
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  first_name : String;
  last_name : String;
  email : String;
  contact_no : String;
  password : String;
  profession : String;
  signupenable : Boolean;
  constructor(
    private validateService:ValidateService,
    private flashMessage: FlashMessagesService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    this.signupenable = false;
  }

  enableSign(){
    if (this.signupenable){
      this.signupenable = false;
    }else{
       this.signupenable = true;;
    }
     
  }

  onsignup(){
    const user = {
      first_name : this.first_name,
      last_name : this.last_name,
      email : this.email,
      contact_no : this.contact_no,
      password : this.password,
      profession : this.profession
    }

    if(!this.validateService.validateSignup(user)){
      this.flashMessage.show('Please fill all the fields', { cssClass: 'alert-danger', timeout: 5000 });
      return false;
    }
    if(!this.validateService.validateEmail(user.email)){
      this.flashMessage.show('Please enter valid email', { cssClass: 'alert-danger', timeout: 5000 });
      return false;
    }
    if(!this.validateService.validatePhoneNumber(user.contact_no)){
      this.flashMessage.show('Please enter valid contact no', { cssClass: 'alert-danger', timeout: 5000 });
      return false;
    }
    if(!this.validateService.validatePassword(user.password)){
      this.flashMessage.show('Password at least one number, one lowercase and one uppercase letter and at least six characters ', { cssClass: 'alert-danger', timeout: 5000 });
      return false;
    }
    if(this.profession == null){
      this.flashMessage.show('Please select your profession.', { cssClass: 'alert-danger', timeout: 5000 });
      return false;
    }
    console.log(user)
    this.authService.signupUser(user).subscribe(data =>{
      if(data.error == null){
        this.flashMessage.show(data.message, { cssClass: 'alert-success', timeout: 5000 });
        this.router.navigate(['/login']);
      }
      else{
          this.flashMessage.show(data.message, { cssClass: 'alert-danger', timeout: 5000 });
      }
    })

  }

}



// WEBPACK FOOTER //
// ./src/app/signup/signup.component.ts